import { DataModel } from 'common/models/utility-models/base-model';

export class UploadDocumentModel extends DataModel {
  record:any[] = []
  tokedata:any;

}


// export class record
// {
//   documentTypeId: string = '';
//   document_name: string = '';
//   applicant_id: string = '';
//   is_verified: string = '';
//   uploaded: string = '';
//   uploadDocId: string = '';
//   fileName: string = '';
//   fileOriginalName: string = '';
// }